export interface LearningGradeSettings {
  effectiveFromMonth: string;
  pointsByCategory: { MANDATORY: number[]; OWN_DEPARTMENT: number[]; OTHER_DEPARTMENT: number[] };
}

export interface GeneralSetting extends GeneralSettingValues {
  learningGradeSettings?: LearningGradeSettings;
}

export interface GeneralSettingValues {
  learningSpeed: number;
  amountPossibleRedirections: number;
  postponedSheetDetection: number;
  amountDaysReviewSuggestionLists: number;
  amountDaysPassStandard: number;
  amountDaysPassStandardForAll: number;
  costPunishmentsAwards: number;
  amountDaysPunishmentExpiredTask: number;
  costSuggestionsList: number;
  costLearning: number;
  cosBeingLate: number;
  bonusCorrectAnswers: number;
  bonusUnCorrectAnswers: number;
  lowLevelOfCorrectQuestion: number;
  percentageOfWagesPerLevel: number;
  skillTestQuestionsCount: number;
  skillTestTimeLimitMinutes: number;
  skillTestPassingPercentage: number;
  vacationAmount: number;
  meritBall: number;
  holidayCoefficient: number;
  amountOfPossiblePostpones: number;
  testRetakeCooldownHours: number;
  testGenerationLimitPerUserPerSpecializationPerDay: number;
  chatMaxOutputTokens: number;
  testGenerationMaxOutputTokens: number;
  maxChatMessageLength: number;
  chatHistoryMessageLimit: number;
  chatMessagesPerUserPerDay: number;
  chatMessagesPerUserPerMinute: number;
  perUserDailyTokenLimit: number;
  globalDailyTokenLimit: number;
  learningControlPeriodMonths: number;
}

export type GeneralSettingEditableField = keyof GeneralSettingValues;

const AI_GENERAL_SETTING_FIELDS: GeneralSettingEditableField[] = [
  'testRetakeCooldownHours',
  'testGenerationLimitPerUserPerSpecializationPerDay',
  'chatMaxOutputTokens',
  'testGenerationMaxOutputTokens',
  'maxChatMessageLength',
  'chatHistoryMessageLimit',
  'chatMessagesPerUserPerDay',
  'chatMessagesPerUserPerMinute',
  'perUserDailyTokenLimit',
  'globalDailyTokenLimit',
  'learningControlPeriodMonths',
];

export function createDefaultGeneralSetting(): GeneralSetting {
  return {
    learningSpeed: 1,
    amountPossibleRedirections: 10,
    postponedSheetDetection: 10,
    amountDaysReviewSuggestionLists: 5,
    amountDaysPassStandard: 30,
    amountDaysPassStandardForAll: 7,
    costPunishmentsAwards: 1,
    amountDaysPunishmentExpiredTask: 2,
    costSuggestionsList: 1,
    costLearning: 1,
    cosBeingLate: 1,
    bonusCorrectAnswers: 1,
    bonusUnCorrectAnswers: 1,
    lowLevelOfCorrectQuestion: 2.8,
    percentageOfWagesPerLevel: 1,
    skillTestQuestionsCount: 20,
    skillTestTimeLimitMinutes: 10,
    skillTestPassingPercentage: 95,
    vacationAmount: 24,
    meritBall: 25,
    holidayCoefficient: 1,
    amountOfPossiblePostpones: 2,
    testRetakeCooldownHours: 12,
    testGenerationLimitPerUserPerSpecializationPerDay: 1,
    chatMaxOutputTokens: 700,
    testGenerationMaxOutputTokens: 12000,
    maxChatMessageLength: 2000,
    chatHistoryMessageLimit: 5,
    chatMessagesPerUserPerDay: 50,
    chatMessagesPerUserPerMinute: 10,
    perUserDailyTokenLimit: 150000,
    globalDailyTokenLimit: 5000000,
    learningControlPeriodMonths: 6,
  };
}

export function mergeGeneralSetting(
  setting?: Partial<GeneralSetting> | null,
): GeneralSetting {
  return Object.assign({}, createDefaultGeneralSetting(), setting || {});
}

export function isAiGeneralSettingField(
  field: GeneralSettingEditableField,
): boolean {
  return AI_GENERAL_SETTING_FIELDS.indexOf(field) !== -1;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/general-setting.model.ts